import React from 'react';
import { Box, makeStyles, TableRow, TableCell } from '@material-ui/core';
import BodyText from './BodyText';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { setBookingHistoryID, toggleFlightDetailModal } from '../../reducers/UiReducer';
import { FlightAgentBookingHistoryDispatch,FlightMailTicketDispatch } from '../../reducers/HomeReducer';
const useStyles = makeStyles(() => ({
	optionsIcon: {
		height: 25,
		width: 25,
		backgroundColor: '#FDE8EE',
		padding: 3,
		borderRadius: '50%',
	},
	tableCell: {
		fontSize: 12,
		// padding: 3,
		color: 'rgb(0 0 0 / 73%)',
		fontWeight: 600,
	},
	img: {
		'& .MuiAvatar-img': {
			width: 30,
			height: 30,
		},
	},
}));
const DashboardTable = ({ item, rowIndex }) => {
	const classes = useStyles();
	const history = useHistory();
	const dispatch = useDispatch();
	const handleMail = ()=>{
		let formMail = {
			orderId: item.orderId,
			userEmail: item.userEmail,
		};
		dispatch(FlightMailTicketDispatch(formMail));
		// window.alert('Ticket Set Successfully')
	}
	// console.log('ItemHistory',item)
	// console.log('bookingDetails',JSON.parse(item.bookingDetails))
	// console.log('pricingDetails',JSON.parse(item.pricingDetails))
	// console.log('selectedFlight',JSON.parse(item.selectedFlight))
	// console.log('selectedPax',JSON.parse(item.selectedPax))
	return (
		<>
			<TableRow
				key={rowIndex}
				style={{
					marginTop: 20,
				}}>
				<TableCell className={classes.tableCell}>{item.orderId}</TableCell>
				<TableCell className={classes.tableCell}>{item.origin}</TableCell>
				<TableCell className={classes.tableCell}>{item.destination}</TableCell>
				<TableCell className={classes.tableCell}>{item.dob}</TableCell>
				<TableCell className={classes.tableCell}>{item.travelDate}</TableCell>
				<TableCell className={classes.tableCell}>
					{`${item.currCode} ${item.ticketCost}`}
				</TableCell>
				<TableCell className={classes.tableCell}>
					{item.bookingStatus}
				</TableCell>
				<TableCell className={classes.tableCell}>
					<i
						class='fa-solid fa-eye'
						style={{ cursor: 'pointer' }}
						onClick={() => {dispatch(toggleFlightDetailModal(true)); dispatch(setBookingHistoryID(item.id))}}></i>
						<i
						class='fa-solid fa-envelope'
						style={{ marginLeft: 5, cursor: 'pointer' }}
						onClick={handleMail}></i>
					{/* <i
						class='fa-solid fa-file-invoice-dollar'
						style={{ marginLeft: 5, cursor: 'pointer' }}
						onClick={() => history.push('/agentinvoice')}></i> */}
					{/* <i
						class='fa-solid fa-file-lines'
						onClick={() => history.push('/agentinvoice')}
						style={{ marginLeft: 5, cursor: 'pointer' }}></i> */}
					<i
						class='fa-solid fa-print'
						onClick={() =>
							history.push({
								pathname:'/ticketdisplay',
								state:item
							})
						}
						style={{ marginLeft: 5, cursor: 'pointer' }}></i>
				</TableCell>
				{/* <TableCell className={classes.tableCell}>{item.bookingId}</TableCell>
				<TableCell className={classes.tableCell}>{item.origin}</TableCell>
				<TableCell className={classes.tableCell}>{item.destination}</TableCell>
				<TableCell className={classes.tableCell}>{item.travelDate}</TableCell>
				<TableCell className={classes.tableCell}>{item.returnDate}</TableCell>
				<TableCell className={classes.tableCell}>
					{item.bookingStatus}
				</TableCell>
				<TableCell className={classes.tableCell}>
					{item.payableAmount}
				</TableCell> */}
			</TableRow>
		</>
	);
};

export default DashboardTable;
